import { styled } from '@mui/material';
import Chart from 'react-apexcharts';
import { useBrandPerformanceMetrics } from 'src/queries';
import { Skeleton } from 'src/ui-components';

import { useGetChartData } from '../hooks/useGetChartData';
import { ChartMetricFilter } from './ChartMetricFilter';

export const ChartMetrics = () => {
  const { series, options } = useGetChartData();
  const { isLoading } = useBrandPerformanceMetrics();
  return (
    <Wrapper>
      <Title>Select and compare organic, paid, and SnS sales.</Title>
      <Filters>
        <ChartMetricFilter chartMetricType={'primaryMetric'} />
        <ChartMetricFilter chartMetricType={'secondaryMetric'} />
      </Filters>

      {isLoading ? (
        <Skeleton h={'400px'} w={'99%'} />
      ) : (
        <Chart options={options} series={series} type="area" height={385} />
      )}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled('div')`
  color: #5f676b;
  font-family: ${({ theme }) => theme.fonts.telka};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

const Filters = styled('div')`
  display: flex;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`;
